import './App.css'
import React, { useEffect } from 'react'
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from 'react-router-dom'
import { connect, Provider } from 'react-redux'
import { store, persistor } from './modules/store/store'
import { PersistGate } from 'redux-persist/integration/react'
import { routes } from './common/constant/routes-constant'

import './common/scss/common.scss'
import { navigationRef } from './common/utils/redirectionUtils'

function NavigationWrapper() {
  const navigate = useNavigate()

  useEffect(() => {
    navigationRef.current = navigate
  }, [])

  return (
    <Routes>
      {routes.map((route) => {
        return (
          <Route
            key={route.key}
            path={route.path}
            authNeeded={route.authNeeded}
            element={route.element}
          />
        )
      })}
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  )
}

function App() {
  return (
    <>
      <BrowserRouter>
        <PersistGate persistor={persistor}>
          <div className="App" id="App">
            <NavigationWrapper />
          </div>
        </PersistGate>
      </BrowserRouter>
    </>
  )
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps)(App)
